/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';
import { EXAMLE, INIT } from './init';
import { useEffect } from 'react';
import { checkValidForm } from './Step1';
import { POLICY_NAME } from '../../POLICY';

const Step2 = (props) => {
    const { previewData, setStep2 } = props;
    const { t } = useTranslation(['translation', POLICY_NAME.COOKIES_POLICY]);

    useEffect(() => {
        if (previewData) {
            let check = true;
            const allowKey = [
                'cookieIntroductionTitleTh',
                'cookieIntroductionTitleEn',
                'cookieWhatAreTitleTh',
                'cookieWhatAreTitleEn',
                'cookieWhatAreContentTh',
                'cookieBenefitTitleTh',
                'cookieBenefitTitleEn',
            ];
            for (const [key, value] of Object.entries(
                previewData?.cookieIntroductionLawfulBasis
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep2(check);
        }
    }, [previewData]);

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep2(true);
            })
            .catch(() => props.setStep2(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.cookieIntroductionLawfulBasis) {
            onValuesChange(
                null,
                props.previewData?.cookieIntroductionLawfulBasis
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'cookieIntroductionTitleTh',
            'cookieIntroductionTitleEn',
            'cookieWhatAreTitleTh',
            'cookieWhatAreTitleEn',
            'cookieWhatAreContentTh',
            'cookieWhatAreContentEn',
            'cookieBenefitTitleTh',
            'cookieBenefitTitleEn',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep2(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('cookies-policy.Introduction and Lawful Basis', {
                    ns: POLICY_NAME.COOKIES_POLICY,
                })}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="cookieIntroductionLawfulBasis"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.cookieIntroductionLawfulBasis}
            >
                {/* Introduction */}
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Introduction')}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieIntroductionTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cookieIntroductionLawfulBasis.cookieIntroductionContentTh.replace(
                            /\{\{d\}\}/g,
                            props.domainName
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieIntroductionContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieIntroductionTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cookieIntroductionLawfulBasis.cookieIntroductionContentEn.replace(
                            /\{\{d\}\}/g,
                            props.domainName
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieIntroductionContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Divider />
                {/* What are cookies */}
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('What are cookies', {
                            ns: POLICY_NAME.COOKIES_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieWhatAreTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={
                            EXAMLE.cookieIntroductionLawfulBasis
                                .cookieWhatAreContentTh
                        }
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieWhatAreContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieWhatAreTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={
                            EXAMLE.cookieIntroductionLawfulBasis
                                .cookieWhatAreContentEn
                        }
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieWhatAreContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Divider />
                {/* Benifit of cookies */}
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Benifit of cookies', {
                            ns: POLICY_NAME.COOKIES_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieBenefitTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={
                            EXAMLE.cookieIntroductionLawfulBasis
                                .cookieBenefitContentTh
                        }
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieBenefitContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.COOKIES_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cookieBenefitTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={
                            EXAMLE.cookieIntroductionLawfulBasis
                                .cookieBenefitContentEn
                        }
                    />
                    <Form.Item
                        className="mt-4"
                        name="cookieBenefitContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <Form.Item
                        hidden
                        name="cookieIntroductionIsDisplay"
                    ></Form.Item>
                    <Form.Item hidden name="cookieWhatAreIsDisplay"></Form.Item>
                    <Form.Item hidden name="cookieBenefitIsDisplay"></Form.Item>
                </div>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                            className="ml-4"
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step2;
